import { EvtHeader } from "components/header";
import React from "react";
import HeaderPortal from "components/portal/header-portal";
import EditItemButton from "components/buttons/edit";
import { PermissionControlledInput } from "permissions/components/input";
import ProjectLayout from "@/modules/work/projects/layout";
import PeopleSection from "./components/people";
import IntegrationsSection from "./components/integrations";
import TagsSection from "./components/tags";
import { ProjectDashboardStatsSection } from "./components/stats";
export default function ProjectDashboard() {
  return (
    <ProjectLayout>
      <ProjectDashboardContent />
    </ProjectLayout>
  );
}
function ProjectDashboardContent() {
  return (
    <>
      <div className="flex-1 overflow-auto">
        <EvtHeader title="Dashboard" />
        <TagsSection />
        <ProjectDashboardStatsSection />
        {/* <BudgetSection /> */}
        {/* <ProjectBillablesSection /> */}
        <PeopleSection />
        <IntegrationsSection />
        {/* <ProjectBurnChart /> */}
        {/* <TimesheetActivitySection /> */}
      </div>
      <HeaderPortal>
        <PermissionControlledInput rule="update:PC,SC,AM" collection="projects">
          <EditItemButton />
        </PermissionControlledInput>
      </HeaderPortal>
    </>
  );
}
